import Player from "@vimeo/player";

class ProductVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector("[data-play]");
    this.pauseButton = this.querySelector("[data-pause]");
    this.content = this.querySelector("[data-content]");
  }

  connectedCallback() {
    this.playButton.addEventListener("click", () => {
      this.playVideo();
    });

    this.pauseButton.addEventListener("click", () => {
      this.pauseVideo();
    });

    this.addEventListener("video:ended", () => {
      this.classList.remove("is-playing");
      this.content.classList.remove("fade-out");
    });
  }

  playVideo() {
    const event = new CustomEvent("video-component:play", {
      bubbles: true,
    });

    this.querySelector("video-snippet").dispatchEvent(event);
    this.classList.add("is-playing");
    this.content.classList.add("fade-out");
  }

  pauseVideo() {
    const event = new CustomEvent("video-component:pause", {
      bubbles: true,
    });

    this.querySelector("video-snippet").dispatchEvent(event);
    this.classList.remove("is-playing");
    this.content.classList.remove("fade-out");
  }
}

if (!customElements.get("product-video")) {
  customElements.define("product-video", ProductVideo);
}
